import { NewDriveItemsAction, NewDriveItemsActionKeys } from './actions';

export interface NewDriveItemsState {
	ids: number[];
	isFetching: boolean;
}

const initialState: NewDriveItemsState = {
	ids: [],
	isFetching: false,
};

export function newDriveItems(state: NewDriveItemsState = initialState, action: NewDriveItemsAction): NewDriveItemsState {
	switch (action.type) {
		case NewDriveItemsActionKeys.REQUEST_NEW_DRIVE_ITEMS:
			return {
				...state,
				isFetching: true,
			};
		case NewDriveItemsActionKeys.RECEIVE_NEW_DRIVE_ITEMS:
			return {
				...state,
				isFetching: false,
			};
		case NewDriveItemsActionKeys.UPDATE_NEW_ITEMS:
			return {
				...state,
				ids: action.ids,
			};
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DriveItemList/New/reducer.ts